import React, { SVGAttributes } from 'react'

const SvgPlus = (props: SVGAttributes<SVGElement>): JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 8 8" {...props}>
    <path fill="#313537" d="M4 8c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v6c0 .6-.4 1-1 1z" />
    <path fill="#313537" d="M7 5H1c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1z" />
  </svg>
)

export default SvgPlus
